const sessionExpiredHandlers = new Set();
export const registerSessionExpiredHandler = (handler)=>{
    sessionExpiredHandlers.add(handler);
    return ()=>{
        sessionExpiredHandlers.delete(handler);
    };
};
export const notifySessionExpired = ()=>{
    sessionExpiredHandlers.forEach((handler)=>handler());
};
